import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import "./App.css";
import "./styles/revamp.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard/pages/NewHome";
import { useLocation } from "react-router-dom";
import { AppContext, mainAPikey } from "./ContextApi";
import { scrollArrowIcon } from "./Assets";
import PolicyDetailsHome from "./pages/PolicyDetails/pages/Home";
import MyCoverageHome from "./pages/MyCoverages/pages/Home";
import MembersCoveredHome from "./pages/MembersCovered/pages/Home";
import Escalation_matrixHome from "./pages/EscalationMatrix/pages/Home";
import DownloadFormsHome from "./pages/DownloadForms/pages/Home";
import NetworkHospitalHome from "./pages/NetworkHospital/pages/Home";
import IntimateClaimsHome from "./pages/InitimateClaims/pages/Home";
import ClaimStatusHome from "./pages/ClaimStatus/pages/Home";
import ClaimSubmissionHome from "./pages/ClaimSubmission/pages/Home";
import ClaimCornerHome from "./pages/Claim Corner/pages/Home";
import BlackListHospitalHome from "./pages/BlackListHospital/pages/Home";
import FAQ_Home from "./pages/Faq/pages/Home";
import EmployeeQueriesHome from "./pages/EmployeeQueries/pages/Home";


function App() {
  const location = useLocation();
  const { token, setToken, setRequestOptions, isScrolledBtnActive, setScrollBtnActive } = useContext(AppContext);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem("authorizationToken"));

  useEffect(() => {
    if (mainAPikey) {
      fetch(`${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/favicon`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to fetch favicon');
          }
          return response.json();
        })
        .then(data => {
          const faviconLink = document.querySelector("link[rel='icon']");
          faviconLink.href = data.favicon || 'default-favicon.ico';
        })
        .catch(error => console.error('Error fetching favicon:', error));
    }
  }, [mainAPikey]);

  const params = new URLSearchParams(location.search);
  const encodedData = params.get('data');

  useEffect(() => {
    if (encodedData) {
      const decodedData = atob(decodeURIComponent(encodedData));
      localStorage.setItem('authorizationToken', `Bearer ${decodedData}`);
      setIsAuthenticated(decodedData);
      setToken(decodedData);

      setRequestOptions(prevOptions => ({
        ...prevOptions,
        headers: {
          ...prevOptions.headers,
          Authorization: `Bearer ${decodedData}`,
        },
      }));

      navigate("/policy-details");
    }
  }, [encodedData, navigate, setToken, setRequestOptions]);

  useEffect(() => {
    const googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: 'en,hi,mr,ta,te,gu,bn',
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
      }, 'google_translate_element');
    };

    const script = document.createElement("script");
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);

    window.googleTranslateElementInit = googleTranslateElementInit;

    return () => {
      document.body.removeChild(script);
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <div className="App">
      <div id="google_translate_element"></div>
      <Routes basename="/employee-login">
        <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/network-hospital" element={isAuthenticated ? <NetworkHospitalHome /> : <Navigate to="/" />} />
        <Route path="/escalation-matrix" element={isAuthenticated ? <Escalation_matrixHome /> : <Navigate to="/" />} />
        <Route path="/members-covered" element={isAuthenticated ? <MembersCoveredHome /> : <Navigate to="/" />} />
        <Route path="/policy-details" element={isAuthenticated ? <PolicyDetailsHome /> : <Navigate to="/" />} />
        <Route path="/download-form" element={isAuthenticated ? <DownloadFormsHome /> : <Navigate to="/" />} />
        <Route path="/claim-status" element={isAuthenticated ? <ClaimStatusHome /> : <Navigate to="/" />} />
        <Route path="/mycoverage" element={isAuthenticated ? <MyCoverageHome /> : <Navigate to="/" />} />
        <Route path="/claim-corner" element={isAuthenticated ? <ClaimCornerHome /> : <Navigate to="/" />} />
        <Route path="/queries" element={isAuthenticated ? <EmployeeQueriesHome /> : <Navigate to="/" />} />
        <Route path="/blacklisted-hospital" element={isAuthenticated ? <BlackListHospitalHome /> : <Navigate to="/" />} />
        <Route path="/intimate-myclaims" element={isAuthenticated ? <IntimateClaimsHome /> : <Navigate to="/" />} />
        <Route path="/faq" element={isAuthenticated ? <FAQ_Home /> : <Navigate to="/" />} />
        <Route path="/claim-submission" element={<ClaimSubmissionHome />} />
        <Route path="/home" element={<Dashboard />} />
      </Routes>
    </div>
  );
}

export default App;
